export const HkpmMapInformation = {
  venue: "HKPM",
  venueId: "HKPM",
  i18nVenue: "venue_palace_museum",
  venueName: "Hong Kong Palace Museum",
  venueName_zh: "香港故宮文化博物館",
  floorAlignment: [
    {
      lcMapId: "4ec23d8f-a1a5-4319-8501-6691fcce9be7",
      id: "TBC_HKPM_-1",
      ordinal: -1,
      name: "LG",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m0-1718355178027JEYALA.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
    {
      lcMapId: "8c6c8ea1-90a4-4ea8-be9a-949a6a831258",
      id: "TBC_HKPM_0",
      ordinal: 0,
      name: "L0",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m1-1718702095995REHAYI.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
    {
      lcMapId: "dcee7824-315f-472a-8240-9d727de935e3",
      id: "TBC_HKPM_1",
      ordinal: 1,
      name: "L1",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m2-1718702562532FIZUSI.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
    {
      lcMapId: "f0b5e6a4-e091-4922-abdd-9baa0898a42f",
      id: "TBC_HKPM_2",
      ordinal: 2,
      name: "L2",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m3-1718702605319QEGUYI.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
    {
      lcMapId: "68e5c0c3-a22a-42b6-9b8f-e7fa592f6352",
      id: "TBC_HKPM_3",
      ordinal: 3,
      name: "L3",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m4-1718702637744BAPEWE.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
    {
      lcMapId: "42286d38-a72b-4d85-980c-0abff35df5f9",
      id: "TBC_HKPM_4",
      ordinal: 4,
      name: "L4",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m5-1718702670793ZOHUCE.png",
      pixInMeter: 20.8194792310068,
      center: { lat: 22.301620666732227, lng: 114.1554200710521 },
      angle: 358.97274743891023,
      scale: 48.03202207611783,
      corners: {
        tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
        tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
        br: { lat: 22.30075201712738, lng: 114.1563932435957 },
        bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
      },
      size: { width: 4096, height: 4096 },
      sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
    },
  ],
  name: "L0",
  imageUrl:
    "https://locaite-dev.collectiv.co/assets/c2461d0c-c362-4236-aaa8-0ce4e3f5b046/m1-1718702095995REHAYI.png",
  pixInMeter: 20.8194792310068,
  center: { lat: 22.301620666732227, lng: 114.1554200710521 },
  angle: 358.97274743891023,
  scale: 48.03202207611783,
  corners: {
    tl: { lat: 22.30248931633708, lng: 114.1544468985085 },
    tr: { lat: 22.30252622803213, lng: 114.1563535646936 },
    br: { lat: 22.30075201712738, lng: 114.1563932435957 },
    bl: { lat: 22.30071510543232, lng: 114.1544865774106 },
  },
  size: { width: 4096, height: 4096 },
  sizeInMeters: { width: 196.1948851364027, height: 197.32575120636898 },
  entry_mapId: 0,
};
